import React from 'react'
import { useTranslation } from "react-i18next";
import { Modal, Box } from "@mui/material";
import Delete from "../../icons/delete.svg";
import Editar from "../../icons/editar.svg";
import { formatoFechasEs } from '../../functions/funciones';
import ComentariosEstructura from '../comentariosEstructura';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '85ch',
    maxHeight: '500px',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    padding: '20px',
    overflow: 'auto',

};

const modal = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

/**
 * Muestra los comentarios principales.
 *
 */

const AllComments = (props) => {
    const { t } = useTranslation('common');

    const eliminar = (id) => {
        props.eliminarComment(id)
        props.handleClose()
    }
    const editar = (id, comentario) => {
        props.editarComment(id, comentario)
        props.handleClose()
    }
    const fijar = (id, fijado) => {
        props.fijarComment(id, fijado)
    }

    return (
        <>
            <Modal
                open={props.opened}
                onClose={props.handleClose}
                className={modal}
            >
                <Box sx={style}>
                    {props.comentarios.length === 0 ?
                        <p>{t('comments.noComments')}</p>
                        :
                        <>
                            <div className="comment-header">
                                <h3>{t('form.comments')}</h3>
                            </div>
                            {props.comentarios.map((comentario, index) => (
                                <ComentariosEstructura 
                                    key={index}
                                    comm={comentario} 
                                    eliminarComment={eliminar}
                                    editarComment={editar}
                                    fijarComment={fijar}
                                />
                                // <div key={index}>
                                //     <img
                                //         src={Delete}
                                //         alt={t('actions.delete')}
                                //         className="tableIcon"
                                //         onClick={() => eliminar(comentario.id)}
                                //         style={{ width: 14 }}
                                //     ></img>
                                //     <img
                                //         src={Editar}
                                //         alt={t('actions.edit')}
                                //         className="tableIcon"
                                //         onClick={() => editar(comentario.id, comentario)}
                                //         style={{ width: 14 }}
                                //     ></img>
                                //     {formatoFechasEs(comentario.createdAt)} - {comentario.usuario?.nombre + " " + comentario.usuario?.apellidos} - {comentario.texto}
                                // </div>
                            ))}
                        </>}
                </Box>
            </Modal>
        </>
    );
}

export default AllComments;